module.exports = __webpack_public_path__ + "static/media/balka3.d2c6bc98.png";